import React, {useContext} from "react";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {
    let summary = (useContext(RecordsManagementContext).IV3_PageDetails || {}).NcBolSummaryData || {};

    return (
        <>
            <div className='ncbol-two-col-row'>
                <div className='ncbol-two-col-left'>
                    <span className='ncbol-top-label'>ORIGIN ADDRESS / CITY: </span>{summary.origin_address_city || 'N/A'}
                </div>
                <div className='ncbol-two-col-right'>
                    <span className='ncbol-top-label'>DESTINATION ADDRESS / CITY: </span>{summary.destination_address_city || 'N/A'}
                </div>
            </div>
            <div className='ncbol-two-col-row'>
                <div className='ncbol-two-col-left'>
                    <span className='ncbol-top-label'>TELEPHONE:</span> {summary.telephone || 'N/A'}
                </div>
                <div className='ncbol-two-col-right'>
                    <span className='ncbol-top-label'>LOAD/UNLOAD DATE(S): </span>{summary.load_unload_dates || 'N/A'}
                </div>
            </div>
        </>
    )
}
